import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createAction } from 'redux-actions';
import { actionKey } from './constants';
export const initializeDuperbrowse = createAction(`${actionKey}/CONFIGURE`, (options)=>options);
export const loadDuperbrowse = createAction(`${actionKey}/LOAD`, (itemId, stream)=>({
        itemId,
        stream
    }));
export const openDuperbrowse = createAction(`${actionKey}/OPEN`, (itemId, stream)=>_object_spread_props(_object_spread({}, stream), {
        currentOpenItem: itemId,
        parent: _object_spread_props(_object_spread({}, stream.parent), {
            url: window.location.href
        })
    }));
export const openDuperbrowseWithEntities = createAction(`${actionKey}/OPEN`, (itemId, stream)=>_object_spread_props(_object_spread({}, stream), {
        currentOpenItem: itemId,
        parent: _object_spread_props(_object_spread({}, stream.parent), {
            url: window.location.href
        })
    }), (_, __, entities)=>({
        entities
    }));
export const exitDuperbrowse = createAction(`${actionKey}/EXIT`, ()=>null);
export const exitDuperbrowseDone = createAction(`${actionKey}/EXIT_DONE`, ()=>null);
export const exitDuperbrowseResorationTimeout = createAction(`${actionKey}/EXIT_RESTORE_TIMEOUT`, ()=>null);
export const moveNext = createAction(`${actionKey}/NEXT`, ()=>null);
export const movePrev = createAction(`${actionKey}/PREV`, ()=>null);
export const unloadDuperbrowseItem = createAction(`${actionKey}/UNLOAD_DUPERBROWSE_ITEM`, (deviation)=>({
        deviation
    }));
export const setCurrentItem = createAction(`${actionKey}/SET_CURRENT_ITEM`, (itemId)=>({
        itemId
    }));
export const setCurrentStreamAndItem = createAction(`${actionKey}/SET_CURRENT_STREAM_AND_ITEM`, (streamId, itemId)=>({
        streamId,
        itemId
    }));
export const shutdownDuperbrowse = createAction(`${actionKey}/SHUTDOWN`, ()=>null);
export const loadDuperbrowseItem = createAction(`${actionKey}/LOAD_ITEM`, (itemId, itemSchema, preloadDirection)=>({
        itemId,
        itemSchema,
        preloadDirection
    }));
